import { SHOW_RELATED_MEDIA_TOOL_ID } from '@/utils/config/elevenlabs';

const SOURCE_LABELS: Record<string, string> = {
  'default-pronunciations': 'Default pronunciations',
  'default-pronunciations-update': 'Default pronunciation update',
  'pronunciation-repair': 'Pronunciation repair',
  'silence-timeout': 'Silence timeout',
  'phone-goals': 'Phone goals',
  'remove-goals-tool': 'Remove Conversation Goals tool',
};

const FIELD_LABELS: Record<string, string> = {
  prompt: 'Prompt',
  systemPrompt: 'Prompt',
  first_message: 'First message',
  firstMessage: 'First message',
  llm: 'LLM model',
  temperature: 'Temperature',
  voice_id: 'Voice',
  voiceId: 'Voice',
  voice_label: 'Voice label',
  report_mode: 'Report mode',
  isMultilingual: 'Language mode',
  daily_limit: 'Call limit',
  max_duration_seconds: 'Max duration',
};

// These hold nested values that describe one setting, so their contents aren't listed separately.
const GROUP_LABELS: Record<string, string> = {
  overrides: 'Conversation overrides',
  dynamic_variable_placeholders: 'Dynamic variables',
};

const TOOL_LABELS: Record<string, string> = {
  [SHOW_RELATED_MEDIA_TOOL_ID]: 'Links & images tool',
  // Retired tool, kept so past jobs still show a readable name.
  tool_2501m4dhyddpejs9dhphv0jh7zva: 'Conversation goals tool',
};

const humanize = (key: string) => {
  const words = key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' ').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const collectFieldLabels = (fields: Record<string, unknown>, labels: Set<string>) => {
  for (const [key, value] of Object.entries(fields)) {
    if (key === 'add_tool_ids' && Array.isArray(value)) {
      value.forEach((toolId) => labels.add(TOOL_LABELS[toolId] ?? 'Tools'));
    } else if (GROUP_LABELS[key]) {
      labels.add(GROUP_LABELS[key]);
    } else if (isObject(value)) {
      collectFieldLabels(value, labels);
    } else {
      labels.add(FIELD_LABELS[key] ?? humanize(key));
    }
  }
};

export const getBulkJobLabel = (kind: string | null, updates: unknown): string => {
  const details = isObject(updates) ? updates : {};
  const source = typeof details.source === 'string' ? details.source : kind;

  if (source === 'settings-restore') return `Undo of job #${details.restores_job_id}`;
  if (source && SOURCE_LABELS[source]) return SOURCE_LABELS[source];

  const labels = new Set<string>();
  collectFieldLabels(isObject(details.params) ? details.params : details, labels);

  return labels.size ? Array.from(labels).join(', ') : 'Not recorded';
};
